import React, { Component } from 'react';

import PlaceJumbotronEditor from './Editor/PlacesJumbotron';
import PlaceJumbotronViewer from './Viewers/PlacesJumbotron';

export default class PlaceJumbotron extends Component {
  state = {
    isEditing: false,
  };
  toggleEditing = () => {
    this.setState({
      isEditing: !this.state.isEditing,
    });
  };
  render() {
    // const { name, banner_images, tagline, altitude: { meters } = {}, text } = this.props;
    const viewer = (
      <PlaceJumbotronViewer {...this.props} toggleEditing={this.toggleEditing} />
    );

    const editor = (
      <PlaceJumbotronEditor {...this.props} toggleEditing={this.toggleEditing} />
    );
    return (
      <div className="no-gutters" id="overview">
        <div className="col-12">{this.state.isEditing ? editor : viewer}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Places/PlaceJumbotron.jsx